export default "__VITE_ASSET__B2wn86M5__"